import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import InboxIcon from "@mui/icons-material/Inbox";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { Alert, Box, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import downloadjs from "downloadjs";
import * as React from "react";
import { Dropdown, IDropdownAction } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { EditItem } from "ui/Scripts/source/models/common/editItem";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ConfirmationDialogResult, EnumHelper, WhistleBlowArchiveState, WhistleBlowArchivingType, WhistleBlowResolution, WhistleBlowSeverity, WhistleBlowSource, WhistleBlowState } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IWhistleBlowEditItem } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItem";
import { IWhistleBlowEditItemMessage, WhistleBlowEditItemMessage } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItemMessage";
import { IWhistleBlowCategoryListItem } from "ui/Scripts/source/models/whistleBlowCategory/whistleBlowCategoryListItem";
import { SaveAttachmentBase64 } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import * as attachmentService from "../../../models/services/attachmentService";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { ISessionState } from "../../../models/session/sessionState";
import { UserListItems } from "../../../models/user/userListItems";
import { AttachmentList } from "../../attachments/AttachmentList";
import { Dialog } from "../../framework/Dialog/Dialog";
import { DialogItemsNav } from "../../framework/Dialog/DialogItemsNav";
import { DialogSectionCard } from "../../framework/Dialog/DialogSectionCard";
import { DialogTabs } from "../../framework/Dialog/DialogTabs";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { SearchField } from "../../framework/SearchField";
import { SelectUnitDialog } from "../../framework/Unit/SelectUnitDialog";
import { UserBlocks } from "../../user/UserBlocks/UserBlocks";
import { WhistleBlowArchiveDialog } from "../WhistleBlowArchiveDialog";
import { WhistleBlowArchiveSelectTypeDialog } from "../WhistleBlowArchiveSelectTypeDialog";
import { WhistleBlowEditDialogLogList } from "../WhistleBlowEditDialogLogList";
import { WhistleBlowEditDialogMessageList } from "../WhistleBlowEditDialogMessageList";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { EditToolButton } from "source/components/framework/Button/EditToolButton";
import { WhistleBlowEditDescriptionDialog } from "./WhistleBlowEditDescriptionDialog";
import { WhistleBlowEditSaveSuccess } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditSaveSuccess";
import { WhistleBlowEdit } from "ui/Scripts/source/models/whistleBlow/whistleBlowEdit";

/* eslint-disable no-unused-vars */
export const enum WhistleBlowEditDialogMenuItem {
    Informant = "1",
    Company = "2",
    Log = "3",
}
/* eslint-enable no-unused-vars */

//WhistleBlowEditDialog
export interface IWhistleBlowEditDialogProp {
    sessionState: ISessionState;
    maxAttachmentsTotalSize: number;
    whistleBlowId: string;
    classes?: string;
    hasPrevious: boolean;
    hasNext: boolean;
    onSaved: () => void;
    onClose: () => void;
    onRefreshList: () => Promise<void>;
    onPrevious: () => void;
    onNext: () => void;
}

export interface IWhistleBlowEditDialogState {
    activeMenuItem: WhistleBlowEditDialogMenuItem;
    whistleBlowStateOptions: IDropdownAction[];
    isLoading: boolean;
    whistleBlow: IWhistleBlowEditItem;
    canReadInformantData: boolean;
    canEditInformantData: boolean;
    isResolved: boolean;
    isArchived: boolean;
    archiveState: WhistleBlowArchiveState;
    units: IIdTitleNode[];
    categories: IWhistleBlowCategoryListItem[];
    unitId: string;
    unitCode: string;
    categoryId: string;
    state: WhistleBlowState;
    stateStr: string;
    severity: WhistleBlowSeverity;
    resolution: WhistleBlowResolution;
    resolutionComment: string;
    source: WhistleBlowSource;
    sourceComment: string;
    id: string;
    rowId: string;
    code: string;
    anonymous: boolean;
    title: string;
    dateStr: string;
    timeStr: string;
    description: string;
    informantName: string;
    informantEmail: string;
    informantPhone: string;
    informantPasswordConfirmed: boolean;
    attachments: IFileAttachment[];
    publicMessages: IWhistleBlowEditItemMessage[];
    internalMessages: IWhistleBlowEditItemMessage[];
    handlers: IModifyUser[];
    showSelectUnitDialog: boolean;
    showWhistleBlowArchiveSelectTypeDialog: boolean;
    showEditDescriptionDialog: boolean;
}

const getStateChipIcon = (state: WhistleBlowState) => {
    switch (state) {
    case WhistleBlowState.New:
        return <CircleIcon color="error" sx={{ fontSize: "16px !important", marginRight: ".5rem" }} />;
    case WhistleBlowState.Received:
        return <MoveToInboxIcon color="warning" sx={{ fontSize: "16px !important", marginRight: ".5rem" }} />;
    case WhistleBlowState.InProgress:
        return <WatchLaterIcon color="info" sx={{ fontSize: "16px !important", marginRight: ".5rem" }} />;
    case WhistleBlowState.Resolved:
        return <CheckCircleIcon color="success" sx={{ fontSize: "16px !important", marginRight: ".5rem" }} />;
    case WhistleBlowState.Archived:
    case WhistleBlowState.Archived1:
    case WhistleBlowState.Archived2:
    case WhistleBlowState.Archived3:
        return <InboxIcon sx={{ fontSize: "16px !important", marginRight: ".5rem" }} />;
    }
};

export class WhistleBlowEditDialog extends React.Component<IWhistleBlowEditDialogProp, IWhistleBlowEditDialogState> {
    private orgStateHash: string = "";

    getWhistleBlowStateOption = (whistleBlowState: WhistleBlowState, classes: string = null): IDropdownAction => {
        const text = EnumHelper.WhistleBlowStateToStr(whistleBlowState);
        return {
            title: <Box display="flex" alignItems="center">{getStateChipIcon(whistleBlowState)}<Typography>{text}</Typography></Box>,
            textTitle: text,
            classes,
            onClick: () => this.handleStateChane(whistleBlowState)
        };
    };

    getWhistleBlowStateOptions = (whistleBlow: IWhistleBlowEditItem): IDropdownAction[] => {
        if (!whistleBlow) {
            return [
                this.getWhistleBlowStateOption(WhistleBlowState.New),
                this.getWhistleBlowStateOption(WhistleBlowState.Received),
                this.getWhistleBlowStateOption(WhistleBlowState.InProgress),
                this.getWhistleBlowStateOption(WhistleBlowState.Resolved)
            ];
        }
        const result: IDropdownAction[] = [];
        if (EnumHelper.isLessThan(whistleBlow.state, WhistleBlowState.Received)) {
            result.push(this.getWhistleBlowStateOption(WhistleBlowState.New));
        }
        if (EnumHelper.isLessThan(whistleBlow.state, WhistleBlowState.InProgress)) {
            result.push(this.getWhistleBlowStateOption(WhistleBlowState.Received));
        }
        if (EnumHelper.isLessThan(whistleBlow.state, WhistleBlowState.Archived)) {
            result.push(this.getWhistleBlowStateOption(WhistleBlowState.InProgress));
        }
        result.push(this.getWhistleBlowStateOption(WhistleBlowState.Resolved));
        if (EnumHelper.isEqual(whistleBlow.state, WhistleBlowState.Archived)) {
            result.push(this.getWhistleBlowStateOption(WhistleBlowState.Archived, "darkSelect"));
        }
        return result;
    };

    constructor(props: IWhistleBlowEditDialogProp) {
        super(props);
        const state = WhistleBlowState.New;
        this.state = {
            activeMenuItem: WhistleBlowEditDialogMenuItem.Informant,
            whistleBlowStateOptions: this.getWhistleBlowStateOptions(null),
            isLoading: false,
            whistleBlow: null,
            canReadInformantData: false,
            canEditInformantData: false,
            isResolved: false,
            isArchived: false,
            archiveState: WhistleBlowArchiveState.NotArchived,
            units: [],
            categories: [],
            unitId: "",
            unitCode: "",
            categoryId: "",
            state,
            stateStr: EnumHelper.WhistleBlowStateToStr(state),
            severity: WhistleBlowSeverity.Unspecified,
            resolution: WhistleBlowResolution.Unspecified,
            resolutionComment: "",
            source: WhistleBlowSource.Unspecified,
            sourceComment: "",
            id: "",
            rowId: "",
            code: "",
            anonymous: true,
            title: "",
            dateStr: "",
            timeStr: "",
            description: "",
            informantName: "",
            informantEmail: "",
            informantPhone: "",
            informantPasswordConfirmed: false,
            attachments: [],
            publicMessages: [],
            internalMessages: [],
            handlers: [],
            showSelectUnitDialog: false,
            showWhistleBlowArchiveSelectTypeDialog: false,
            showEditDescriptionDialog: false
        };
    }

    setWhistleBlowEditToState = (result: WhistleBlowEdit): boolean => {
        const whistleBlow = result.whistleBlow;
        const state = {
            ...this.state,
            activeMenuItem: this.state.activeMenuItem === WhistleBlowEditDialogMenuItem.Informant && !result.canReadInformantData
                ? WhistleBlowEditDialogMenuItem.Company
                : this.state.activeMenuItem,
            whistleBlowStateOptions: this.getWhistleBlowStateOptions(whistleBlow),
            whistleBlow,
            canReadInformantData: result.canReadInformantData,
            canEditInformantData: result.canEditInformantData,
            isResolved: EnumHelper.isEqual(whistleBlow.state, WhistleBlowState.Resolved),
            isArchived: EnumHelper.isEqual(whistleBlow.state, WhistleBlowState.Archived),
            archiveState: whistleBlow.archiveState,
            units: result.units,
            categories: result.categories,
            unitId: whistleBlow.unitId,
            unitCode: whistleBlow.unitCode,
            categoryId: whistleBlow.categoryId,
            state: whistleBlow.state,
            stateStr: EnumHelper.WhistleBlowStateToStr(whistleBlow.state),
            severity: whistleBlow.severity,
            resolution: whistleBlow.resolution,
            resolutionComment: whistleBlow.resolutionComment,
            source: whistleBlow.source,
            sourceComment: whistleBlow.sourceComment,
            id: whistleBlow.id,
            rowId: whistleBlow.rowId,
            code: whistleBlow.code,
            anonymous: whistleBlow.anonymous,
            title: whistleBlow.title,
            dateStr: Base.timeToDateStr(whistleBlow.date),
            timeStr: Base.timeToTimeStr(whistleBlow.date),
            description: whistleBlow.description,
            informantName: whistleBlow.informantName,
            informantEmail: whistleBlow.informantEmail,
            informantPhone: whistleBlow.informantPhone,
            informantPasswordConfirmed: whistleBlow.informantPasswordConfirmed,
            attachments: whistleBlow.attachments,
            publicMessages: whistleBlow.messages.filter(i => !i.isInternal),
            internalMessages: whistleBlow.messages.filter(i => i.isInternal),
            handlers: whistleBlow.handlers
        };
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(this.props, state).hash;
        return result.canReadInformantData;
    };

    loadData = async (id: string): Promise<boolean> => {
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => whistleBlowService.getWhistleBlowEdit(id), false, false, () => this.setState({ isLoading: false }));
        if (!result) return false;
        return this.setWhistleBlowEditToState(result);
    };

    componentDidMount(): void {
        this.loadData(this.props.whistleBlowId);
    }

    async componentDidUpdate(prevProps: IWhistleBlowEditDialogProp, prevState: IWhistleBlowEditDialogState): Promise<void> {
        const props = this.props;
        const state = this.state;
        if (prevProps.whistleBlowId === props.whistleBlowId) return;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            if (!await this.saveToDb()) return;
            if (!props.onRefreshList) {
                await props.onRefreshList();
            }
        }
        const canReadInformantData = await this.loadData(props.whistleBlowId);
        if (prevState.canReadInformantData !== canReadInformantData) {
            this.setState({
                activeMenuItem: canReadInformantData
                    ? WhistleBlowEditDialogMenuItem.Informant
                    : WhistleBlowEditDialogMenuItem.Company
            });
        }
    }

    handleToggleActiveMenuItem = (tabId: WhistleBlowEditDialogMenuItem) => {
        this.setState({ activeMenuItem: tabId });
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "title") {
            this.setState({ title: value });
        } else if (name === "description") {
            this.setState({ description: value });
        } else if (name === "unitId") {
            this.setState({ unitId: value });
        } else if (name === "categoryId") {
            this.setState({ categoryId: value });
        } else if (name === "severity") {
            this.setState({ severity: value.toInteger() });
        } else if (name === "resolution") {
            this.setState({ resolution: value.toInteger() });
        } else if (name === "resolutionComment") {
            this.setState({ resolutionComment: value });
        } else if (name === "source") {
            this.setState({ source: value.toInteger() });
        } else if (name === "sourceComment") {
            this.setState({ sourceComment: value });
        } else if (name === "informantName") {
            this.setState({ informantName: value });
        } else if (name === "informantEmail") {
            this.setState({ informantEmail: value });
        } else if (name === "informantPhone") {
            this.setState({ informantPhone: value });
        }
    };

    handleStateChane = (state: WhistleBlowState) => {
        this.setState({
            state,
            stateStr: EnumHelper.WhistleBlowStateToStr(state)
        });
    };

    handleDateChange = (value: string) => {
        this.setState({ dateStr: value });
    };

    handleTimeChange = (value: string) => {
        this.setState({ timeStr: value });
    };

    // #region Attachments
    handleAttachmentDownload = async (id: string) => {
        if (!id) return;
        const state = this.state;
        const attachment = state.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        if (attachment.isNew()) return;
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    getRemoveAttachmentsSaveData = (state: IWhistleBlowEditDialogState, category: number, attachmentIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", state.id);
        result.append("category", category);
        result.append("ids", attachmentIds);
        return result;
    };

    refreshMessages = async () => {
        const result = await AppUtils.callService(() => whistleBlowService.getWhistleBlowMessages(this.props.whistleBlowId), false);
        if (!result) return;
        this.setState({
            publicMessages: result.items.filter(i => !i.isInternal),
            internalMessages: result.items.filter(i => i.isInternal),
        });
    };

    handleAttachmentRemove = async (category: number, id: string) => {
        if (!id) return;
        const state = this.state;
        const removingInformantData = category === 0 && !state.canEditInformantData;
        const saveData = this.getRemoveAttachmentsSaveData(state, category, [id]);
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveAttachmentParameter, state.attachments.find(x => x.id === id)?.name), false) === ConfirmationDialogResult.No) return;
        const result = await AppUtils.callService(() => whistleBlowService.whistleBlowEditRemoveAttachments(saveData.obj));
        if (!result) return;
        this.setState({
            attachments: state.attachments.filter(i => i.id !== id)
        });
        if (!removingInformantData) return;
        await this.refreshMessages();
    };

    getAddAttachmentsSaveData = async (state: IWhistleBlowEditDialogState, category: number, attachments: IFileAttachment[]): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("id", state.id);
        result.append("category", category);
        result.append("attachments", await SaveAttachmentBase64.fromFileAttachments(attachments));
        return result;
    };
    
    handleAttachmentsAdd = async (category: number, fileList: FileList) => {
        const state = this.state;
        const removingInformantData = category === 0 && !state.canEditInformantData;
        const attachments = await FileAttachment.addFileListToFileAttachments([], fileList, category);
        if (attachments.length < 1) return;
        if (category < 1) {
            if (!AppUtils.validateFileAttachments(state.attachments.concat(attachments), Translations.MaximumTotalSizeOfAttachmentsIsParameterMB, this.props.maxAttachmentsTotalSize)) return;
        }
        const saveData = await this.getAddAttachmentsSaveData(state, category, attachments);
        const result = await AppUtils.callService(() => whistleBlowService.whistleBlowEditAddAttachments(saveData.obj));
        if (!result) return;
        EditItem.setItemIdsFromIds(attachments, result.ids);
        this.setState({
            attachments: state.attachments.concat(attachments)
        });
        if (!removingInformantData) return;
        await this.refreshMessages();
    };
    // #endregion Attachments

    // #region Messages
    handleMessageAdded = (internal: boolean, newMessage: IWhistleBlowEditItemMessage) => {
        if (!newMessage) return;
        const state = this.state;
        if (internal) {
            this.setState({
                internalMessages: WhistleBlowEditItemMessage.sortWhistleBlowEditItemMessages(state.internalMessages.concat([newMessage]))
            });
        } else {
            this.setState({
                publicMessages: WhistleBlowEditItemMessage.sortWhistleBlowEditItemMessages(state.publicMessages.concat([newMessage]))
            });
        }
    };

    handleMessageRead = (internal: boolean, id: string) => {
        if (!id) return;
        const state = this.state;
        if (internal) {
            const internalMessages = state.internalMessages.slice(0);
            const message = internalMessages.find(i => i.id === id && !i.isRead);
            message.isRead = true;
            this.setState({
                internalMessages
            });
        } else {
            const publicMessages = state.publicMessages.slice(0);
            const message = publicMessages.find(i => i.id === id && !i.isRead);
            message.isRead = true;
            this.setState({
                publicMessages
            });
        }
    };
    // #endregion Messages

    // #region Select Unit
    handleSelectUnit = () => {
        this.setState({
            showSelectUnitDialog: true
        });
    };

    handleSelectUnitDialogOk = async (node: IIdTitleNode) => {
        const state = this.state;
        if (!node) return;
        const result = await AppUtils.callService(() => whistleBlowService.getDefaultWhistleBlowHandlersForUnit(node.id));
        if (!result) return null;
        const oldHandlerCodes = state.handlers.map(i => i.code);
        this.setState({
            showSelectUnitDialog: false,
            unitId: node.id,
            unitCode: node.title
        });
        //Save added handlers
        this.addHandlers(result.items.filter(i => oldHandlerCodes.indexOf(i.code) < 0), false);
    };

    handleSelectUnitDialogCancel = () => {
        this.setState({
            showSelectUnitDialog: false
        });
    };
    // #endregion Select Unit

    // #region Handlers
    addHandlers = async (users: IModifyUser[], showSuccessMessage: boolean): Promise<ApiSuccess> => {
        const state = this.state;
        if (!users || users.length < 1) return null;
        const result = await AppUtils.callService(() => whistleBlowService.whistleBlowEditAddHandlers(state.id, users.map(i => i.code)), showSuccessMessage);
        if (!result) return null;
        this.setState({
            handlers: ModifyUser.sortModifyUsers(state.handlers.concat(users))
        });
        return result;
    };

    handleAddHandlers = async (users: IModifyUser[]): Promise<ApiSuccess> => {
        return this.addHandlers(users, true);
    };

    handleRemoveHandlers = async (userCodes: string[]): Promise<ApiSuccess> => {
        const state = this.state;
        if (!userCodes || userCodes.length < 1) return null;
        const result = await AppUtils.callService(() => whistleBlowService.whistleBlowEditRemoveHandlers(state.id, userCodes));
        if (!result) return null;
        this.setState({
            handlers: state.handlers.filter(i => userCodes.indexOf(i.code) < 0)
        });
        return result;
    };
    
    handleGetHandlersSelectListItems = (companyId: string, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, _ignoreQrCodeUsers: boolean, _requireQrCodeUsers: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
        const state = this.state;
        return whistleBlowService.getHandlersSelectUserListItems(state.id, state.unitId, pageSize, page, filter,
            ignoreUserIds, ignoreUserCodes, activityState, ignoreRecordUserConnected, doNotIgnoreRecordUserConnectedUserCode,
            sortColumn, sortOrderIsAsc);
    };
    // #endregion Handlers

    // #region Description
    handleEditDescription = () => {
        this.setState({
            showEditDescriptionDialog: true
        });
    };

    handleWhistleBlowEditDescriptionDialogOk = async (description: string, rowId: string) => {
        this.setState({
            description,
            rowId,
            showEditDescriptionDialog: false
        });
        await this.refreshMessages();
    };

    handleWhistleBlowEditDescriptionDialogCancel = (): void => {
        this.setState({
            showEditDescriptionDialog: false
        });
    };
    // #endregion Description

    getArchiveStateText = () => {
        const state = this.state;
        const whistleBlow = state.whistleBlow;
        const result = state.stateStr;
        if (state.state !== WhistleBlowState.Archived || whistleBlow.state !== WhistleBlowState.Archived) return result;
        return result + " (" + Translations.AType.toLocaleLowerCase() + " " + whistleBlow.archiveState.toString(10) + ")";
    };

    getSaveDataFromState = (props: IWhistleBlowEditDialogProp, state: IWhistleBlowEditDialogState, returnNewData?: boolean): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("rowId", state.rowId);
        result.append("id", state.id);
        result.append("unitId", state.unitId);
        result.append("categoryId", state.categoryId ? state.categoryId : null);
        result.append("title", state.title);
        result.append("description", state.description);
        result.append("state", state.state);
        result.append("severity", state.severity);
        result.append("resolution", state.resolution);
        result.append("resolutionComment", state.resolutionComment);
        result.append("source", state.source);
        result.append("sourceComment", state.sourceComment);
        result.append("date", Base.getDateTime(state.dateStr, state.timeStr).getTime());
        result.append("anonymous", state.anonymous);
        result.append("informantName", state.informantName);
        result.append("informantEmail", state.informantEmail);
        result.append("informantPhone", state.informantPhone);
        result.append("returnNewData", returnNewData);
        return result;
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (state.canEditInformantData && !state.title) {
                AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
                return resolve(false);
            }
            if (state.canEditInformantData && !state.dateStr) {
                AppUtils.showErrorMessage(Translations.DateMustBeDefined);
                return resolve(false);
            }
            if (state.canEditInformantData && !state.timeStr) {
                AppUtils.showErrorMessage(Translations.TimeMustBeDefined);
                return resolve(false);
            }
            if (state.canEditInformantData && !state.description) {
                AppUtils.showErrorMessage(Translations.DescriptionMustBeDefined);
                return resolve(false);
            }
            const dateTime = Base.getDateTime(state.dateStr, state.timeStr).getTime();
            if (dateTime > Base.getNowTicks()) {
                AppUtils.showErrorMessage(Translations.WhistleBlowDateAndTimeCannotBeInFuture);
                return resolve(false);
            }
            if (EnumHelper.isEqual(state.state, WhistleBlowState.Resolved)) {
                if (EnumHelper.isEqual(state.resolution, WhistleBlowResolution.Unspecified)) {
                    AppUtils.showErrorMessage(Translations.WhistleBlowResolutionTypeMustBeDefined);
                    return resolve(false);
                }
            }
            return resolve(true);
        });
    };

    saveToDb = async (returnNewData?: boolean): Promise<WhistleBlowEditSaveSuccess> => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        const saveData = this.getSaveDataFromState(props, state, returnNewData);
        //Call server
        const result = await AppUtils.callService(() => whistleBlowService.saveWhistleBlowEdit(saveData.obj));
        if (!result) return null;
        //Update state and hash
        if (!returnNewData) {
            const stateChange = { id: result.id, rowId: result.rowId };
            this.orgStateHash = this.getSaveDataFromState(props, { ...state, ...stateChange }).hash;
            this.setState(stateChange);
        } else {
            this.setWhistleBlowEditToState(result);
        }
        return result;
    };

    handleSave = async (closeDialog: boolean) => {
        const result = await this.saveToDb(!closeDialog);
        if (!result) return;
        if (!closeDialog) {
            this.props.onSaved();
            return;
        }
        this.props.onClose();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave(true);
        } else {
            props.onClose();
        }
    };

    canMoveOut = async (): Promise<boolean> => {
        const props = this.props;
        return await AppUtils.canMoveOut(this.getSaveDataFromState(props, this.state).hash, this.orgStateHash,
            async () => !!await this.saveToDb(),
            props.onRefreshList,
            (newStateHash) => { this.orgStateHash = newStateHash; }
        );
    };

    handlePrevious = async () => {
        if (!await this.canMoveOut()) return;
        this.props.onPrevious();
    };

    handleNext = async () => {
        if (!await this.canMoveOut()) return;
        this.props.onNext();
    };

    // #region Archiving Type
    handleArchive = async () => {
        this.setState({
            showWhistleBlowArchiveSelectTypeDialog: true
        });
    };

    handleWhistleBlowArchiveSelectTypeDialogOk = async (archivingType: WhistleBlowArchivingType) => {
        const state = this.state;
        const result = await WhistleBlowArchiveDialog.archiveWhistleBlows(archivingType, [state.id]);
        if (!result) return;
        this.props.onClose();
    };
    
    handleWhistleBlowArchiveSelectTypeDialogCancel = () => {
        this.setState({
            showWhistleBlowArchiveSelectTypeDialog: false
        });
    };
    // #endregion Archiving Type

    getAlertSeverity = (severity: string) => {
        switch (severity) {
        case "0":
            return "error";
        case "1":
            return "warning";
        default:
            return "info";
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        const whistleBlow = state.whistleBlow;
        if (!whistleBlow) return null;
        const newIsResolved = EnumHelper.isEqual(state.state, WhistleBlowState.Resolved);
        const canEditInformantData = !state.isResolved && !state.isArchived && state.canEditInformantData;
        const canEditInformantAttachments = !state.isResolved && !state.isArchived;
        const arhivedOnlyStateChange = EnumHelper.isEqual(whistleBlow.archiveState, WhistleBlowArchiveState.OnlyStateChange);
        const arhivedInformantDataRemoved = EnumHelper.isEqual(whistleBlow.archiveState, WhistleBlowArchiveState.InformantDataRemoved);
        const arhivedAllDataRemoved = EnumHelper.isEqual(whistleBlow.archiveState, WhistleBlowArchiveState.AllDataRemoved);
        const canBeSaved = !arhivedInformantDataRemoved && !arhivedAllDataRemoved;
        const canBeArchived = whistleBlow && (state.isResolved || arhivedOnlyStateChange || arhivedInformantDataRemoved);
        return (
            <>
                <Dialog
                    id="wb-edit-dialog"
                    onClose={this.handleCancel}
                    maxWidth="xl"
                    maxHeight="100%"
                    title={Translations.EditWhistleBlow + ": " + whistleBlow.code}
                    dialogTabs={
                        <DialogTabs
                            activeTabId={state.activeMenuItem}
                            tabs={[
                                { id: WhistleBlowEditDialogMenuItem.Informant, title: Translations.WhistleBlowInformation },
                                { id: WhistleBlowEditDialogMenuItem.Company, title: Translations.Handling },
                                { id: WhistleBlowEditDialogMenuItem.Log, title: Translations.Log }
                            ]}
                            onChangeTab={this.handleToggleActiveMenuItem}
                        />
                    }
                    body={
                        <Box display="flex" flexDirection="column" height="100%" overflow="hidden">
                            <Box display="flex" flexGrow={2} alignItems="flex-start" overflow={"hidden"}>
                                {(state.activeMenuItem === WhistleBlowEditDialogMenuItem.Informant) &&
                                    (state.canReadInformantData
                                        ? (
                                            <GridRow sx={{ height: "100%" }}>
                                                <Grid item sm={4} sx={{ height: "100%" }}>
                                                    <DialogSectionCard headerTitle={Translations.WhistleBlowInformation} overflowY="auto">
                                                        <GridRow>
                                                            <Grid item sm={6}>
                                                                <FormField title={Translations.WhistleBlowCreateTime} margin={0}>
                                                                    <Typography>{Base.timeToDateTimeStr(whistleBlow.createDate)}</Typography>
                                                                </FormField>
                                                            </Grid>
                                                            <Grid item sm={6}>
                                                                <FormField title={Translations.WhistleBlowDateAndTime} required margin={0}>
                                                                    <GridRow>
                                                                        <Grid item sm={12}>{state.dateStr + " " + state.timeStr}</Grid>
                                                                    </GridRow>
                                                                </FormField>
                                                            </Grid>
                                                        </GridRow>
                                                        <FormField title={Translations.Title} required>
                                                            <TextField type="text" name="title" title={Translations.Title} value={state.title} disabled={!canEditInformantData} onChange={this.handleChange} size="small" />
                                                        </FormField>
                                                        <FormField
                                                            title={Translations.WhistleBlowDescription}
                                                            required
                                                            buttons={!canEditInformantData
                                                                ? <EditToolButton
                                                                    tooltip={Translations.WhistleBlowEditDescription}
                                                                    onClick={this.handleEditDescription}
                                                                />
                                                                : undefined
                                                            }
                                                        >
                                                            <TextField name="description" title={Translations.WhistleBlowDescription} multiline rows={5} value={state.description} disabled={!canEditInformantData} onChange={this.handleChange} size="small" fullWidth />
                                                        </FormField>
                                                        {canEditInformantData &&
                                                            <FormField title="">
                                                                <FormControlLabel
                                                                    label={Translations.WhistleBlowAnonymousReport}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={state.anonymous}
                                                                            onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                                                this.setState({ anonymous: checked });
                                                                            }}
                                                                        />
                                                                    }
                                                                    slotProps={{ typography: { variant: "body2" } }}
                                                                />
                                                            </FormField>
                                                        }
                                                        {!state.anonymous &&
                                                        <>
                                                            <FormField title={Translations.Name} fullWidth>
                                                                <TextField type="text" name="informantName" title={Translations.Name} value={state.informantName} disabled={!canEditInformantData} onChange={this.handleChange} size="small" fullWidth />
                                                            </FormField>
                                                            <FormField title={Translations.EmailAddress} fullWidth>
                                                                <TextField type="text" name="informantEmail" title={Translations.EmailAddress} value={state.informantEmail} disabled={!canEditInformantData} onChange={this.handleChange} size="small" fullWidth />
                                                            </FormField>
                                                            <FormField title={Translations.Phone} fullWidth>
                                                                <TextField type="text" name="informantPhone" title={Translations.Phone} value={state.informantPhone} disabled={!canEditInformantData} onChange={this.handleChange} size="small" />
                                                            </FormField>
                                                        </>
                                                        }
                                                        <AttachmentList
                                                            isReadOnly={!canEditInformantAttachments}
                                                            title={<label className="control-label">{Translations.Attachments}</label>}
                                                            attachments={state.attachments.filter(i => i.category === 0)}
                                                            onRemoveAttachment={(id) => this.handleAttachmentRemove(0, id)}
                                                            onDownloadAttachment={this.handleAttachmentDownload}
                                                            onAddAttachments={(fileList) => this.handleAttachmentsAdd(0, fileList)}
                                                        />
                                                    </DialogSectionCard>
                                                </Grid>
                                                <Grid item sm={4} sx={{ height: "100%" }}>
                                                    <DialogSectionCard headerTitle={Translations.WhistleBlowState} overflowY="auto">
                                                        <FormField title={Translations.State} margin={0}>
                                                            <Dropdown
                                                                disabled={!canBeSaved}
                                                                startIcon={getStateChipIcon(state.state)}
                                                                selectedTitle={this.getArchiveStateText()}
                                                                selectMode={true}
                                                                actions={state.whistleBlowStateOptions.map((whistleBlowStateOption) => {
                                                                    return { ...whistleBlowStateOption, selected: state.stateStr === whistleBlowStateOption.textTitle };
                                                                })}
                                                            />
                                                        </FormField>
                                                        {whistleBlow.toBeReceivedDate > 0 &&
                                                            <FormField title="">
                                                                <Alert variant="outlined" severity={this.getAlertSeverity(whistleBlow.toBeReceivedDateUrgency.toString(10))}>{String.format(Translations.WhistleBlowMustBeReceivedLatestAtParameter, Base.timeToDateStr(whistleBlow.toBeReceivedDate))}</Alert>
                                                            </FormField>
                                                        }
                                                        {whistleBlow.toBeRespondedDate > 0 &&
                                                            <FormField title="">
                                                                <Alert variant="outlined" severity={this.getAlertSeverity(whistleBlow.toBeRespondedDateUrgency.toString(10))}>{String.format(Translations.WhistleBlowInformantMustBeNotifiedLatestAtParameter, Base.timeToDateStr(whistleBlow.toBeRespondedDate))}</Alert>
                                                            </FormField>
                                                        }
                                                        {!state.isArchived && whistleBlow.resolvedDate > 0 &&
                                                            <FormField title="">
                                                                <Alert variant="outlined" severity="info" title={Translations.WhistleBlowStateResolved + " " + Base.timeToDateStr(whistleBlow.resolvedDate)}>{Translations.WhistleBlowStateResolved + " " + Base.timeToDateStr(whistleBlow.resolvedDate)}</Alert>
                                                            </FormField>
                                                        }
                                                        <FormField title={Translations.Resolution}>
                                                            <Select name="resolution" title={Translations.Resolution} value={state.resolution.toString(10)} onChange={this.handleChange} disabled={!newIsResolved} size="small" fullWidth>
                                                                <MenuItem key={WhistleBlowResolution.Unspecified} value={WhistleBlowResolution.Unspecified.toString(10)}>{Translations.WhistleBlowResolutionUnspecified}</MenuItem>
                                                                <MenuItem key={WhistleBlowResolution.Resolved} value={WhistleBlowResolution.Resolved.toString(10)}>{Translations.WhistleBlowResolutionResolved}</MenuItem>
                                                                <MenuItem key={WhistleBlowResolution.Rejected} value={WhistleBlowResolution.Rejected.toString(10)}>{Translations.WhistleBlowResolutionRejected}</MenuItem>
                                                                <MenuItem key={WhistleBlowResolution.Canceled} value={WhistleBlowResolution.Canceled.toString(10)}>{Translations.WhistleBlowResolutionCanceled}</MenuItem>
                                                                <MenuItem key={WhistleBlowResolution.Junk} value={WhistleBlowResolution.Junk.toString(10)}>{Translations.WhistleBlowResolutionJunk}</MenuItem>
                                                                <MenuItem key={WhistleBlowResolution.Other} value={WhistleBlowResolution.Other.toString(10)}>{Translations.WhistleBlowResolutionOther}</MenuItem>
                                                            </Select>
                                                        </FormField>
                                                        <FormField title={Translations.ResolutionDescription}>
                                                            <TextField name="resolutionComment" title={Translations.ResolutionDescription} multiline rows={5} value={state.resolutionComment} disabled={!newIsResolved} onChange={this.handleChange} size="small" fullWidth />
                                                        </FormField>
                                                    </DialogSectionCard>
                                                </Grid>
                                                <Grid item sm={4} sx={{ height: "100%" }}>
                                                    <DialogSectionCard headerTitle={Translations.Messages} overflowY="hidden">
                                                        <WhistleBlowEditDialogMessageList
                                                            messages={state.publicMessages}
                                                            whistleBlowId={state.id}
                                                            internalMessages={false}
                                                            maxAttachmentsTotalSize={props.maxAttachmentsTotalSize}
                                                            isReadOnly={state.isResolved || state.isArchived || canEditInformantData}
                                                            onWhistleBlowMessageSaved={this.handleMessageAdded}
                                                            onWhistleBlowMessageRead={this.handleMessageRead}
                                                        />
                                                    </DialogSectionCard>
                                                </Grid>
                                            </GridRow>
                                        )
                                        : (
                                            <Box display="flex" justifyContent="center" alignSelf="center" flexGrow={2}>
                                                <Alert severity="info">{Translations.UserNotAllowedToViewNotifier}</Alert>
                                            </Box>
                                        )
                                    )
                                }
                                {state.activeMenuItem === WhistleBlowEditDialogMenuItem.Company &&
                                    <GridRow sx={{ height: "100%" }}>
                                        <Grid item sm={4} sx={{ height: "100%" }}>
                                            <DialogSectionCard headerTitle={Translations.Handling} overflowY="auto">
                                                <FormField title={Translations.Unit} margin={0}>
                                                    <SearchField disabled value={state.unitCode} onSubmit={this.handleSelectUnit} buttonTitle={Translations.Select} buttonVisible={!state.isArchived} />
                                                </FormField>
                                                <UserBlocks
                                                    companyId={props.sessionState.companyId}
                                                    isReadOnly={state.isArchived}
                                                    title={Translations.Handlers}
                                                    noUsersMessage={Translations.AddHandlers}
                                                    parentIsNew={false}
                                                    parentIsNewMessage={Translations.NewWhistleBlowMustBeSavedBeforeHandlersCanBeAdded}
                                                    users={canBeSaved ? state.handlers : []}
                                                    removeUsersConfirmation={Translations.DoYouReallyWantToRemoveSelectedHandlers}
                                                    onAddUsers={this.handleAddHandlers}
                                                    onRemoveUsers={this.handleRemoveHandlers}
                                                    onGetUserSelectListItems={this.handleGetHandlersSelectListItems}
                                                />
                                                <FormField title={Translations.Severity}>
                                                    <Select name="severity" title={Translations.Severity} value={state.severity.toString(10)} onChange={this.handleChange} disabled={state.isArchived} size="small" fullWidth>
                                                        <MenuItem key={WhistleBlowSeverity.Unspecified} value={WhistleBlowSeverity.Unspecified.toString(10)}>{Translations.WhistleBlowSeverityUnspecified}</MenuItem>
                                                        <MenuItem key={WhistleBlowSeverity.VeryLow} value={WhistleBlowSeverity.VeryLow.toString(10)}>{Translations.WhistleBlowSeverityVeryLow}</MenuItem>
                                                        <MenuItem key={WhistleBlowSeverity.Low} value={WhistleBlowSeverity.Low.toString(10)}>{Translations.WhistleBlowSeverityLow}</MenuItem>
                                                        <MenuItem key={WhistleBlowSeverity.Normal} value={WhistleBlowSeverity.Normal.toString(10)}>{Translations.WhistleBlowSeverityNormal}</MenuItem>
                                                        <MenuItem key={WhistleBlowSeverity.High} value={WhistleBlowSeverity.High.toString(10)}>{Translations.WhistleBlowSeverityHigh}</MenuItem>
                                                        <MenuItem key={WhistleBlowSeverity.Critical} value={WhistleBlowSeverity.Critical.toString(10)}>{Translations.WhistleBlowSeverityCritical}</MenuItem>
                                                    </Select>
                                                </FormField>
                                                <FormField title={Translations.Category}>
                                                    <Select name="categoryId" title={Translations.Category} value={state.categoryId} onChange={this.handleChange} disabled={state.isArchived} size="small" fullWidth>
                                                        <MenuItem key="x" value="">{Translations.WhistleBlowSeverityUnspecified}</MenuItem>
                                                        {state.categories.map((category) =>
                                                            <MenuItem key={category.id} value={category.id}>{category.code}</MenuItem>
                                                        )}
                                                    </Select>
                                                </FormField>
                                                <FormField title={Translations.Source}>
                                                    <Select name="source" title={Translations.Source} value={state.source.toString(10)} onChange={this.handleChange} disabled={!canEditInformantData} size="small" fullWidth>
                                                        <MenuItem key={WhistleBlowSource.Unspecified} value={WhistleBlowSource.Unspecified.toString(10)}>{Translations.WhistleBlowSourceUnspecified}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.System} value={WhistleBlowSource.System.toString(10)}>{Translations.WhistleBlowSourceSystem}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.Phone} value={WhistleBlowSource.Phone.toString(10)}>{Translations.WhistleBlowSourcePhone}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.Email} value={WhistleBlowSource.Email.toString(10)}>{Translations.WhistleBlowSourceEmail}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.Mail} value={WhistleBlowSource.Mail.toString(10)}>{Translations.WhistleBlowSourceMail}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.Oral} value={WhistleBlowSource.Oral.toString(10)}>{Translations.WhistleBlowSourceOral}</MenuItem>
                                                        <MenuItem key={WhistleBlowSource.Other} value={WhistleBlowSource.Other.toString(10)}>{Translations.WhistleBlowSourceOther}</MenuItem>
                                                    </Select>
                                                </FormField>
                                                <FormField title={Translations.SourceDescription} fullWidth>
                                                    <TextField name="sourceComment" title={Translations.SourceDescription} inputProps={{ maxLength: 1000 }} value={state.sourceComment} onChange={this.handleChange} disabled={!canEditInformantData} multiline rows={6} size="small" fullWidth />
                                                </FormField>
                                            </DialogSectionCard>
                                        </Grid>
                                        <Grid item sm={4} sx={{ height: "100%" }}>
                                            <DialogSectionCard headerTitle={Translations.InternalAttachments} overflowY="hidden">
                                                <AttachmentList
                                                    title={<label className="control-label">{Translations.InternalAttachments}</label>}
                                                    isReadOnly={state.isArchived}
                                                    margin={0}
                                                    attachments={state.attachments.filter(i => i.category !== 0)}
                                                    onRemoveAttachment={(id) => this.handleAttachmentRemove(1, id)}
                                                    onDownloadAttachment={this.handleAttachmentDownload}
                                                    onAddAttachments={(fileList) => this.handleAttachmentsAdd(1, fileList)}
                                                />
                                            </DialogSectionCard>
                                        </Grid>
                                        <Grid item sm={4} sx={{ height: "100%" }}>
                                            <DialogSectionCard headerTitle={Translations.InternalMessages} overflowY="hidden">
                                                <WhistleBlowEditDialogMessageList
                                                    messages={state.internalMessages}
                                                    whistleBlowId={state.id}
                                                    internalMessages={true}
                                                    maxAttachmentsTotalSize={props.maxAttachmentsTotalSize}
                                                    isReadOnly={state.isArchived}
                                                    onWhistleBlowMessageSaved={this.handleMessageAdded}
                                                    onWhistleBlowMessageRead={this.handleMessageRead}
                                                />
                                            </DialogSectionCard>
                                        </Grid>
                                    </GridRow>
                                }
                                {state.activeMenuItem === WhistleBlowEditDialogMenuItem.Log &&
                                    <WhistleBlowEditDialogLogList
                                        whistleBlowId={state.id}
                                    />
                                }
                            </Box>
                        </Box>
                    }
                    actions={
                        <Box display="flex" justifyContent="space-between" width="100%">
                            <DialogItemsNav
                                hasPrevious={props.hasPrevious}
                                hasNext={props.hasNext}
                                onPrevious={this.handlePrevious}
                                onNext={this.handleNext}
                            />
                            <DialogButtons
                                removeTitle={Translations.Archive}
                                onCancel={this.handleCancel}
                                onRemove={canBeArchived ? this.handleArchive : null}
                                onSave={canBeSaved ? () => this.handleSave(false) : null}
                            />
                        </Box>
                    }
                />
                {state.showSelectUnitDialog &&
                    <SelectUnitDialog
                        nodes={state.units}
                        title={Translations.SelectUnit}
                        firstColumnTitle={Translations.Unit}
                        selectedId={state.unitId}
                        onOk={this.handleSelectUnitDialogOk}
                        onCancel={this.handleSelectUnitDialogCancel}
                    />
                }
                {state.showWhistleBlowArchiveSelectTypeDialog &&
                    <WhistleBlowArchiveSelectTypeDialog
                        type1Disabled={arhivedOnlyStateChange || arhivedInformantDataRemoved}
                        type2Disabled={arhivedInformantDataRemoved}
                        onOk={this.handleWhistleBlowArchiveSelectTypeDialogOk}
                        onCancel={this.handleWhistleBlowArchiveSelectTypeDialogCancel}
                    />
                }
                {state.showEditDescriptionDialog &&
                    <WhistleBlowEditDescriptionDialog
                        id={state.id}
                        rowId={state.rowId}
                        unitId={state.unitId}
                        description={state.description}
                        onOk={this.handleWhistleBlowEditDescriptionDialogOk}
                        onCancel={this.handleWhistleBlowEditDescriptionDialogCancel}
                    />
                }
            </>
        );
    }
}